import { render, staticRenderFns } from "./BankPix.vue?vue&type=template&id=0992cb63&scoped=true&"
import script from "./BankPix.vue?vue&type=script&lang=js&"
export * from "./BankPix.vue?vue&type=script&lang=js&"
import style0 from "./BankPix.vue?vue&type=style&index=0&id=0992cb63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992cb63",
  null
  
)

export default component.exports